module.exports = __webpack_public_path__ + "img/logo-wms-new.4be41f37.png";